import React, {useState} from 'react';
import '../css/_cookies.scss';
import {getCookie, setCookie} from '../cookies';

const COOKIE_CONTROL_MAX_AGE_SECONDS = 31536000;

const isCookieAccepted = () => {
    if (typeof document === 'undefined') return false;
    return getCookie('CookieControl') === 'true';
};

function Cookies() {
    const [CookieControl, setCookieControl] = useState(isCookieAccepted);
    const [isAgreementChecked, setIsAgreementChecked] = useState(isCookieAccepted);

    const handleChange = (e) => {
        const {checked} = e.target;
        setIsAgreementChecked(checked);
        setCookie('CookieControl', checked ? 'true' : 'false', COOKIE_CONTROL_MAX_AGE_SECONDS);
        setCookieControl(checked);
    };

    return (
        <div
            className={
                CookieControl
                    ? 'cookie_control cookie_control_hide'
                    : 'cookie_control cookie_control_show'
            }
        >
            <section>
                <p>
                    We use cookies to enhance your browsing experience by recognising when you log
                    in and any preferred settings and for analysing how you use our site which helps
                    us to troubleshoot any problems and to monitor our own performance.{' '}
                    <a href="/cookies">
                        Take a look at our Cookie Policy to learn more and change your preferences.
                    </a>
                </p>
                <label className="checkbox_wrapper" htmlFor="future">
                    <input
                        className="checkbox"
                        type="checkbox"
                        name="future"
                        checked={isAgreementChecked}
                        onChange={handleChange}
                        id="future"
                    />
                    <span
                        style={{background: 'white'}}
                        className="checkbox_custom trigger_filter"
                        id="future_check"
                        aria-hidden="true"
                    />
                    <span className="label">Accept cookies policy and continue</span>
                </label>
            </section>
        </div>
    );
}

export default Cookies;
